<template>
  <EndForm :config="false" :endform_theme="endform_theme" />
</template>

<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import EndForm from "../../components/FormUI/EndForm.vue";
export default {
  components: { EndForm },
  data() {
    return {
      endform_theme: {
        bg_color: "#FBFBFBFF",
        bg_image: false,
        bg_image_url: "",
        bg_repeat: "repeat",
        bg_position_x: "left",
        bg_position_y: "top",
        bg_size: "auto",
        image: false,
        image_url:
          "https://chatme04.chatme.co.th/CMStorage/endform_1628063085970.png",
        image_size: 400,
        text_color: "#000000",
        text_justify: "center",
        text_size: 30,
        button: {
          bg_color: "#395DA5FF",
          text: "ทำแบบทดสอบอีกครั้ง",
          text_color: "#FFFFFFFF",
          bt_texttype: "button",
          bt_block: false,
          bt_rounded: false,
        },
      },
    };
  },
  created() {
    if (this.$route.query) {
      this.getSurveyByID();
    }
  },
  methods: {
    getSurveyByID() {
      this.$store
        .dispatch("getSurveyByID", this.$route.query.surveyID)
        .then((response) => {
          if (response.data.endform_theme) {
            this.endform_theme = response.data.endform_theme;
          }
          document.getElementById("app").style.backgroundColor =
            this.endform_theme.bg_color;
          document.getElementById("app").style.backgroundImage = this
            .endform_theme.bg_image
            ? `url(${this.endform_theme.bg_image_url})`
            : "";
          document.getElementById(
            "app"
          ).style.backgroundPosition = `${this.endform_theme.bg_position_x} ${this.endform_theme.bg_position_y}`;
          document.getElementById("app").style.backgroundRepeat =
            this.endform_theme.bg_repeat;
          document.getElementById("app").style.backgroundSize =
            this.endform_theme.bg_size;
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            text:
              Object.keys(err.data).length === 0
                ? "ไม่พบแบบสอบถาม"
                : "ไม่สามารถดึงข้อมูล survey ได้",
            title: "",
          }).then(() => {
            if (this.$route.query.shared_token) {
              this.CloseQuestion();
            }
          });
        });
    },
    CloseQuestion() {
      let jwtdata = jwtDecode(this.$route.query.shared_token);
      if (this.$route.query.socialType) {
        if (
          this.$route.query.socialType === "ONECHAT" &&
          this.$route.query.token &&
          this.$route.query.socialID
        ) {
          let jwtdataonechat = jwtDecode(jwtdata.access_token);
          this.$axios.post(
            "https://chat-api.one.th/message/api/v2/disable_webview",
            {
              user_id: jwtdataonechat.sub,
              bot_id: this.$route.query.socialID,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (
          this.$route.query.socialType === "ONEPLATFORM" &&
          this.$route.query.token
        ) {
          this.$axios.post(
            "https://platform.one.th/chat/api/v1/chatbot-api/close-web-view",
            {
              one_id: jwtdata.sub,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (this.$route.query.socialType === "FACEBOOK") {
          Swal.fire({
            html: "กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "รับทราบ",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
